<template>
  <div class="wrapper">
    <div class="wrapper-top">
      <div class="title">海外直邮包装指南和禁寄物品</div>
      <div class="container">
        <div class="container-item">
          <div class="container-item-title">快递包装指南</div>
          <div>
            1.快递包裹可由客户打包、代收点打包等。客户打包可以选择自行打包，也可也到我司现场打包(需收取相应包装费)。<br><br>
            2.请勿在一个包装箱里装入过多的物品。<br><br>
            3.如果不是我司包装的货物，发件人需要对自己的包装负责。<br><br>
            4.蜂蜜，由于蜂蜜密度比较高，塑料包装不是很结实，应选择气柱袋等材料包装。<br><br>
            5.奶粉，应选用气柱袋或者气泡袋、塑料泡沫等内包装。<br><br>
            6.玻璃瓶、塑料瓶等易碎物品，应采用气柱袋等内包装。<br><br>
            7.液体、乳状物品，必须使用良好的包装材料进行包装，以避免该货物破损之后污染其它物品。<br><br>
            8.请用厚实的纸箱进行包装，如果箱子和托运物品间有空隙，请加入适当的填充物品，诸如塑料泡沫、气泡袋、气泡膜等。<br><br>
            9.因报纸可能涉及因文化差异导致的其他不可控因素，我们不建议在包装内填充报纸。<br><br>
            详细包装标准：<br><br>
            请咨询我司工作人员。<br><br>
          </div>
        </div>

      </div>
    </div>

    <div class="container-item embargo">
      <div class="embargo-top">
        <div class="container-item-title">禁运物品</div>
      </div>
      <div class="container-item-inner">
        <img src="../../../assets/embargo.png" alt="">

      </div>
    </div>
    <div class="wrapper-top">
      <div class="target">
        <div>
          中华人民共和国禁止携带、邮寄进境的动植物及其产品名录
        </div>
        <a href="http://www.gov.cn/zwgk/2012-03/02/content_2081510.htm" target="_blank">http://www.gov.cn/zwgk/2012-03/02/content_2081510.htm</a>
      </div>

    </div>
  </div>
</template>

<script>
    export default {
        name: "embargo"
    }
</script>

<style scoped>
  .wrapper{
    width: 100%;
    text-align: center;
  }
  .wrapper-top{
    width: 1000px;
    display: inline-block;
  }
  .container{
    text-align: left;
    padding: 36px 42px 0 42px;
    line-height: 19px;
    font-size: 16px;
    color: rgb(102,102,102);
  }
  .container-item{
    border-bottom: 1px solid rgb(238,238,238);
    margin-bottom: 32px;
  }
  .container-item-title{
    width: 130px;
    height: 37px;
    background: rgb(51,51,51);
    text-align: center;
    line-height: 37px;
    color: #ffffff;
    border-radius: 5px;
    margin-bottom: 21px;
  }
  .container-item-inner{
    background: rgb(242,242,242);
    text-align: center;
    margin: 0;
    padding: 0;
  }
  .embargo-top{
    width: 1000px;
    display: inline-block;
    padding: 0 42px;
    box-sizing: border-box;
  }
  .container-item-inner img{
    width: 850px;

  }
  .target{
    text-align: left;
    font-size: 18px;
    line-height: 30px;
    color: rgb(51,51,51);
    padding: 0 42px 20px;
    font-weight: bold;
  }
  .target a{
    color: rgb(255,97,97);
    font-weight: normal;
    font-size: 14px;
  }
</style>



// WEBPACK FOOTER //
// src/view/PageService/components/embargo.vue